import React from 'react'
import { Column } from 'primereact/column'
import TimeBodyTemplate from './TimeBodyTemplate'
import TimeEditor from './TimeEditor'
import TimeFilterTemplate from '../Filters/TimeFilterTemplate'

const TimeColumn = ({ title, mapsToField, filter, sortable, editable, isTimeFieldChanged, validationErrors }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="numeric"
            body={(rowData) => (
                <span className={`${isTimeFieldChanged(rowData, mapsToField) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    <TimeBodyTemplate rowData={rowData} field={mapsToField} />
                </span>
            )}
            editor={editable ? (options) => <TimeEditor key={options.rowData._editKey} options={options} validationErrors={validationErrors} /> : null}
            filterElement={(options) => <TimeFilterTemplate options={options} />}
            {...filterAttributes}/>
    )
}

export default TimeColumn
